import { useCsvControllerGetTemplatesByModuleQuery } from '../../api/imports-api/imports-api';
import { formatLabel } from '../utils';

export const useTemplatesByModule = () => {
  const { data } = useCsvControllerGetTemplatesByModuleQuery();
  const moduleOptions = data ? Object.keys(data).map((key) => ({ label: formatLabel(key), value: key })) : [];
  return { moduleOptions, templatesByModule: data };
};
